<!-- 器械基础资料 -->
<template>
    <div class='page_content'>
        <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="100%">
            <terminalLineAction v-if="showStatus" ref="terminalLineAction" @drawerCancel="drawerCancel" @toDetail="toDetail" :actionData="actionData"></terminalLineAction>
        </el-drawer>
        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" :buttonFlag="false"></v-button>
        </div>
        <div class="page_content_center">
            <div class="left">
                <el-menu :default-active="defaultActive" class="el-menu-vertical-demo">
                    <el-menu-item :index="String(item.lineId)" v-for="(item, index) in typeList" :key="index" @click="toTab(item.lineId)">
                        <i class="el-icon-document"></i>
                        <span slot="title">{{item.lineName}}</span>
                    </el-menu-item>
                </el-menu>
            </div>
            <div class="right">
                <div class="right_top">
                    <el-breadcrumb>
                        <el-breadcrumb-item>{{ defaultObj.lineName }}</el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
                <el-table ref="myTable" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row size="mini" @row-click="rowClick">
                    <el-table-column align="center" label="选择操作" width="80">
                        <template slot-scope="scope">
                            <el-radio v-model="selectedDataIndex" :label="scope.row.index" border size="mini">
                                <i class="el-icon-thumb"></i>
                            </el-radio>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" show-overflow-tooltip label="线路等级" prop="level" min-width="80"></el-table-column>
                    <el-table-column align="center" show-overflow-tooltip label="终端客户" prop="tcmName" min-width="120"></el-table-column>
                    <el-table-column align="center" show-overflow-tooltip label="结算比例" prop="settleRate" min-width="80"></el-table-column>
                    <el-table-column align="center" show-overflow-tooltip label="是否起始节点" prop="isStart" min-width="80">
                        <template slot-scope="scope">
                            <el-tag size="mini" v-if="scope.row.isStart==1">是</el-tag>
                            <el-tag size="mini" v-else type="danger">否</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" show-overflow-tooltip label="是否末尾节点" prop="isEnd" min-width="80">
                        <template slot-scope="scope">
                            <el-tag size="mini" v-if="scope.row.isEnd==1">是</el-tag>
                            <el-tag size="mini" v-else type="danger">否</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" show-overflow-tooltip label="客户名称" prop="cmName" min-width="120"></el-table-column>
                    <el-table-column align="center" show-overflow-tooltip label="客户ID" prop="cmId" min-width="120"></el-table-column>
                    <el-table-column align="center" show-overflow-tooltip label="供应商" prop="smName" min-width="120"></el-table-column>
                    <el-table-column align="center" show-overflow-tooltip label="供应商ID" prop="smId" min-width="120"></el-table-column>
                    <el-table-column align="center" show-overflow-tooltip label="排序" prop="sort" min-width="80"></el-table-column>
                </el-table>
            </div>
        </div>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" :smId="smId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
    </div>
</template>
<script>
import SearchScheme from "@/byComponents/SearchScheme.vue";
import terminalLineAction from "@/components/terminalLineAction.vue";
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
        terminalLineAction,
    },
    data() {
        //这里存放数据
        return {
            buttonList: [],
            formList: [],
            tableHeight: 0,
            getRequestData: {},
            returnData: {
                list: [],
            },
            seId: "",
            seWidth: "",
            seTitle: "",
            seWidth: "",
            DialogVisible: false,
            seType: "",
            smId: "",
            parentSearchData: {},
            sField: "",
            requesUrl: "",
            ormId: JSON.parse(sessionStorage.getItem('userInfo')).ormId,
            showStatus: false,
            actionData: {},
            //--------
            typeList: [],
            operationList: [],
            defaultActive: "",
            defaultObj: {},
            selectedDataIndex: 0,
        };
    },
    //方法集合
    methods: {
        rowClick(row) {
            this.selectedDataIndex = row.index
        },
        //--------------------------------
        toTab(val) {
            console.log(val);

            var arr = this.typeList.filter(val1 => val1.lineId == val)
            console.log(this.typeList);

            this.defaultObj = arr[0]
            this.defaultActive = String(val)
            this.getDataList()
        },
        // 子组件触发
        drawerCancel(e) {
            this.showStatus = false;
            if (e == 1) this.getType()
        },
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1;
                this.getRequestData.end = time;
            }
        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            console.log(orderId)
            if (orderId) {
                // 设置为true 打开穿透组件首页
                var isPenetrate = true;
                // 设置缓存 存入点击单号
                this.resetSetItem("penetrateOrderId", orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage(
                    {
                        //向窗口发送MessageEvent消息
                        cmd: "returnFormJson",
                        params: { isPenetrate }, //参数
                    },
                    "*"
                );
            }
        },
        getSeWidth(e) {
            console.log(e);
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            console.log(e);
            this.seTitle = e;
        },
        // 检索Id, 索引(表格中), 标识
        openSearch({ sId, index, type, sField }) {
            this.DialogVisible = true;
            this.seId = sId;
            this.sField = sField;
            this.parentSearchData[type] = this.getRequestData[type];
        },
        //检索带回数据
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.paramValue(val);
            }
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.getRequestData[item] = val[item];
            });
        },

        // 获取数据列表
        async getPageInfo() {
            var obj = this.$common.getSearchData(this.formList, 'page', "rows", 30, true)
            for (const key in obj) {
                this.$set(this.getRequestData, key, obj[key])
            }
            this.getButtonList()
        },
        clear(val) {
            if (val) {
                var arr = val.split(",")
                arr.forEach(item => {
                    this.$set(this.getRequestData, item, "")
                })
            }
        },
        // 动作集合
        actionSet(actionData) {
            console.log(actionData);
            switch (actionData.actionType) {
                case 0:
                    this.showStatus = true
                    this.actionData = {
                        cate: 0,
                        oldData: "",
                        orderId: Number(this.defaultActive),
                    }
                    break;
                case 1:
                    if (this.returnData.list.length == 0) {
                        return this.$message.error('暂无数据')
                    }
                    var dataInfo = this.returnData.list[this.selectedDataIndex]
                    if (!dataInfo) {
                        return this.$message.error("请勾选数据")
                    }

                    this.showStatus = true
                    this.actionData = {
                        cate: 1,
                        oldData: dataInfo,
                        orderId: Number(this.defaultActive),
                    }
                    break;
                case 2:
                    if (this.returnData.list.length == 0) {
                        return this.$message.error('暂无数据')
                    }
                    var dataInfo = this.returnData.list[this.selectedDataIndex]
                    if (!dataInfo) {
                        return this.$message.error("请勾选数据")
                    }
                    this.delOnSub()
                    break;
            }
        },
        delOnSub() {
            var dataInfo = this.returnData.list[this.selectedDataIndex]
            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                var delData = {
                    ids: [dataInfo.id]
                }
                let responseData = await this.$http.lineDetaildelete(delData)
                if (responseData.status == 200) {
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                    this.getType()
                } else {
                    this.$message({
                        message: responseData.message,
                        type: 'error'
                    });
                }

            }).catch(() => { });
        },
        // 数据搜索
        searchData() {
            this.getType();
        },
        //手术类型列表
        async getType() {
            this.typeList = []
            const res = await this.$http.terminalLinequeryAll({})
            console.log(res);

            if (res.status == 200) {
                this.typeList = res.result
                this.defaultActive = String(this.typeList[0].lineId)
                this.defaultObj = this.typeList[0]
                this.getDataList()
            }

        },
        // 获取数据列表
        async getDataList() {
            this.returnData.list = []
            const params = [Number(this.defaultActive)]
            let responseData = await this.$http.lineDetailqueryByLineId({ ids: params });
            if (responseData.status == 200) {
                this.returnData.list = this.$common.getIndex(responseData.result)
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
async getButtonList() {
            this.buttonList = await this.$common.getActionButton();
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.requesUrl = this.$store.getters.getConfig.requestUrl;
        this.getPageInfo()
        this.getType()//手术类型列表
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {


    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() {
        this.tableHeight = this.$common.getTableHeight()
    }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.page_content_center {
    display: flex;
    justify-content: space-between;
}

.left {
    flex-shrink: 0;
}

.el-menu-vertical-demo {
    width: 200px;
}

.right {
    width: calc(100vw - 220px);
}

.right_top {
    padding: 5px;
    background-color: #409eff;
}

::v-deep .el-menu-item,
::v-deep .el-submenu__title {
    height: 30px;
    line-height: 30px;
}

::v-deep .el-menu-item-group__title {
    padding: 0;
}

::v-deep .el-breadcrumb__inner,
::v-deep .el-breadcrumb__separator {
    color: #fff !important;
    font-size: 15px;
    font-weight: bold;
}
</style>